import PropTypes from 'prop-types';
import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';

import { resetCourses } from '../../actions';
import PageLayout from '../../components/PageLayout';
import { COURSE_UNDER_REVIEW } from '../../constants/heapEvents';
import analytics from '../../lib/analytics';
import { track } from '../../lib/heapHelpers';
import { customerGuidSelector, applicationIdSelector } from '../../reducers/selectors';

const CourseUnderReviewPage = ({ customerGuid, applicationId, dispatchResetCourses }) => {
  const { REACT_APP_PLATFORM_DASHBOARD: PLATFORM_DASHBOARD_URL } = process.env;

  useLayoutEffect(() => {
    track(COURSE_UNDER_REVIEW, {
      'Customer GUID': customerGuid,
      'Application GUID': applicationId,
    });
    dispatchResetCourses();
  }, []);

  const handleSubmit = () => {
    analytics.sendEvent('Click - Go to dashboard', 'course-under-review');
  };

  return (
    <PageLayout title="The course you selected is currently under review">
      <div className="row-spacer">
        <p>
          We have saved your details and will contact you in 2-3 days once the course is available
          so that you can proceed with your application.
        </p>
      </div>
      <div className="row">
        <div className="col col--auto">
          <a
            href={`${PLATFORM_DASHBOARD_URL}`}
            className="link-button link-button--inverted"
            onClick={handleSubmit}
          >
            Go to dashboard
          </a>
        </div>
      </div>
    </PageLayout>
  );
};

CourseUnderReviewPage.propTypes = {
  dispatchResetCourses: PropTypes.func.isRequired,
  customerGuid: PropTypes.string.isRequired,
  applicationId: PropTypes.string.isRequired,
};

export const mapStateToProps = store => ({
  customerGuid: customerGuidSelector(store),
  applicationId: applicationIdSelector(store),
});

export const mapDispatchToProps = {
  dispatchResetCourses: resetCourses,
};

export { CourseUnderReviewPage };

export default connect(mapStateToProps, mapDispatchToProps)(CourseUnderReviewPage);
